/* @flow */

import * as React from 'react';
import { useId } from 'react-aria';
import { useDispatch } from 'react-redux';

import {
  registerPortal,
  unRegisterPortal,
} from '../slice/portalRegistrationSlice';

export default function usePortalRegister(portalKey: string): Object {
  const dispatch = useDispatch();
  const id = useId();

  React.useEffect(() => {
    dispatch(registerPortal({ portalKey, id }));
    return () => {
      dispatch(unRegisterPortal(id));
    };
  }, []);

  return id;
}
